"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByTranslation = exports.safeFormatMessage = void 0;
/**
 * Safely formats a message using the provided internationalization (intl) object and messages.
 * If the message is found in the messages object, it is formatted using intl.formatMessage.
 * Otherwise, the original key is returned as the result.
 *
 * @returns {string} The formatted message or the original key if the message is not found.
 */
const safeFormatMessage = ({ intl, messages, key }) => {
    if (messages[key]) {
        return intl.formatMessage(messages[key]);
    }
    return key;
};
exports.safeFormatMessage = safeFormatMessage;
const sortByTranslation = (a, b, intl, messages) => {
    const aTranslation = (0, exports.safeFormatMessage)({ intl, messages, key: a });
    const bTranslation = (0, exports.safeFormatMessage)({ intl, messages, key: b });
    return aTranslation.localeCompare(bTranslation);
};
exports.sortByTranslation = sortByTranslation;
//# sourceMappingURL=intl.js.map